import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32254fed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-16" }
const _hoisted_2 = { class: "container lg:grid hidden mx-auto justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "plant--title w-48"
}
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"32px"},
  class: "font-extrabold text-center text-primary-dark"
}
const _hoisted_5 = { class: "year" }
const _hoisted_6 = {
  class: "flex flex-col mb-40",
  style: {"margin-left":"70px","max-width":"70vw"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "absolute bottom-0 right-0 text-right text-white p-20" }
const _hoisted_9 = { class: "font-bold mb-2 lg-text-56px font-sarabun" }
const _hoisted_10 = { class: "font-semibold lg:text-4xl text-base mb-12" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Learn more ")
const _hoisted_12 = {
  key: 0,
  class: "mt-10 flex justify-center"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" See more ")
const _hoisted_14 = { class: "lg:hidden grid mx-auto justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "plant--title w-12",
  style: {"margin-top":"0px !important"}
}
const _hoisted_16 = {
  class: "absolute",
  style: {"left":"95px"}
}
const _hoisted_17 = {
  key: 0,
  style: {"font-size":"32px"},
  class: "font-extrabold text-primary-dark whitespace-nowrap"
}
const _hoisted_18 = {
  class: "font-bold font-sarabun",
  style: {"font-size":"56px"}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "absolute bottom-0 right-4 text-right text-white p-4" }
const _hoisted_21 = {
  class: "font-bold font-sarabun",
  style: {"font-size":"36px"}
}
const _hoisted_22 = { class: "font-semibold text-2xl" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Learn more ")
const _hoisted_24 = {
  key: 0,
  class: "mt-10 flex justify-center"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" See more ")

import _ from 'lodash';
import { ref, onMounted, watch, computed } from 'vue';
import { ForestAll, ForestList } from '@/types/Forest';
import useForest from '@/composables/useForest';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const grouped = ref();
const isLoading = ref(true);
const { forestAll, getForestAll } = useForest();
const curentPage = ref<number>(1);
const entities = ref<ForestAll>({ entities: [], page_information: {} });
onMounted(async () => {
  await getForestAll(curentPage.value);
  entities.value.entities.push(...(forestAll.value.entities as ForestList[]));
  entities.value.page_information = forestAll.value.page_information;
});

const loadDataMore = async () => {
  curentPage.value++;
  if (
    curentPage.value <= (entities.value?.page_information?.last_page as number)
  )
    await getForestAll(curentPage.value);
  entities.value.entities.push(...(forestAll.value.entities as ForestList[]));
};

watch(
  () => entities,
  () => {
    grouped.value = _.mapValues(
      _.groupBy(entities.value.entities, 'year'),
      (list: ForestList[]) =>
        list.map((entities: ForestList) => _.omit(entities, 'year'))
    );
  },
  { deep: true }
);

const onImgLoad = () => {
  isLoading.value = false;
};
const lastYear = computed(() => {
  return parseInt(
    Object.keys(grouped.value)[Object.keys(grouped.value).length - 1]
  );
});

const fristYear = computed(() => {
  return parseInt(Object.keys(grouped.value)[0]);
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grouped.value, (p, year) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "step",
          key: year
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p, (f, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "v-stepper",
              key: i
            }, [
              (i === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (year == _unref(fristYear))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Our Forests "))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      class: _normalizeClass(["header", { ' mt-6': i === 0 }])
                    }, "Planted in", 2),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(year), 1)
                  ]))
                : _createCommentVNode("", true),
              (year != _unref(lastYear) && i === 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "line",
                    style: _normalizeStyle({ height: `calc(100% - ${i === 0 ? 200 : 132}px)` })
                  }, null, 4))
                : _createCommentVNode("", true)
            ])), [
              [_vShow, !isLoading.value]
            ])
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "relative mb-6 w-full",
                style: {"max-width":"880px"},
                key: i
              }, [
                _createElementVNode("img", {
                  onLoad: onImgLoad,
                  class: "rounded-2xl",
                  src: f.image.original_image_url,
                  alt: ""
                }, null, 40, _hoisted_7),
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(f.name), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(f.country), 1),
                  _createVNode(_component_router_link, {
                    to: `/landing/forest/${f.id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseButton, {
                        style: {"font-weight":"700 !important"},
                        "color-scheme": "white",
                        secondary: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ], 512), [
                  [_vShow, !isLoading.value]
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128)),
      (entities.value?.page_information?.last_page)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (curentPage.value < entities.value.page_information.last_page)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  "color-scheme": "border",
                  onClick: loadDataMore
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grouped.value, (p, year) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "step mr-12 responsive",
          style: {"margin-left":"0 !important"},
          key: year
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p, (f, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "v-stepper",
              key: i
            }, [
              (i === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (year == _unref(fristYear))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Our Forests "))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", {
                        class: _normalizeClass(["text-gray-description font-semibold whitespace-nowrap text-2xl", { ' mt-6': i === 0 }])
                      }, " Planted in ", 2),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(year), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (year != _unref(lastYear) && i === 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["line", { 'mt-52': year == _unref(fristYear), 'mt-40': year != _unref(fristYear) }]),
                    style: _normalizeStyle({
              height: `calc(100% - ${i === 0 ? 180 : 100}px)`,
            })
                  }, null, 6))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-col ml-16", { 'mt-52': year == _unref(fristYear), 'mt-40': year != _unref(fristYear) }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "relative mb-6 pr-4 w-full",
                style: {},
                key: i
              }, [
                _createElementVNode("img", {
                  class: "rounded-2xl h-full object-cover",
                  src: f.image.original_image_url,
                  style: {"max-height":"350px"},
                  alt: "",
                  onLoad: onImgLoad
                }, null, 40, _hoisted_19),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(f.name), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(f.country), 1),
                  _createVNode(_component_router_link, {
                    to: `/landing/forest/${f.id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BaseButton, {
                        style: {"font-weight":"700 !important","padding":"12px 40px !important"},
                        "color-scheme": "white",
                        secondary: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ], 2)
        ]))
      }), 128)),
      (entities.value?.page_information?.last_page)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (curentPage.value < entities.value.page_information.last_page)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  "color-scheme": "border",
                  onClick: loadDataMore
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})